import React from "react";
import Footer from "./modules/core/components/footer/Footer";
import NavBar from "./modules/core/components/navbar/NavBar";
import AppRoutes from "./components/routing/AppRoutes";

/**
 * Main App Component
 * Clean and maintainable with centralized routing
 */
const App: React.FC = () => {
  return (
    <>
      <NavBar />
      <div className="app">
        <AppRoutes />
      </div>
      <Footer />
    </>
  );
};

export default App;
